import React from 'react';
import { Package, TrendingUp, Globe } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-100 font-sans selection:bg-slate-700" data-id="element-0">
      {/* Header */}
      <header className="border-b border-slate-800" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center" data-id="element-2">
          <div className="flex items-center gap-3" data-id="element-3">
            <div className="w-10 h-10 bg-gradient-to-br from-slate-700 to-slate-800 rounded-lg flex items-center justify-center font-bold text-xl tracking-tighter border border-slate-700" data-id="element-4">
              CS
            </div>
            <span className="font-semibold text-lg tracking-wide" data-id="element-5">
              Seiji Commerce Solutions
            </span>
          </div>
        </div>
      </header>

      <main data-id="element-6">
        {/* Intro Section */}
        <section className="py-20 lg:py-24" data-id="element-7">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
            <div className="max-w-4xl" data-id="element-9">
              <h1 className="font-syne text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 leading-[1.1] text-transparent bg-clip-text bg-gradient-to-r from-slate-100 via-slate-200 to-slate-400" data-id="element-10">
                Everything E-commerce, Marketing, & Advertising
              </h1>
              <p className="text-lg text-slate-400 leading-relaxed" data-id="element-11">
                Seiji Commerce Solutions owns and operates a portfolio of
                direct-to-consumer ecommerce brands across multiple verticals.
              </p>
            </div>
          </div>
        </section>

        {/* Brand Portfolio */}
        <section className="py-16 border-t border-slate-800/50" data-id="element-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
            <h2 className="text-2xl font-semibold mb-12 text-slate-300" data-id="element-14">
              Our Brands
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-15">
              {/* Brand Placeholder 1 */}
              <div className="group border border-slate-800 rounded-xl overflow-hidden bg-slate-900/50" data-id="element-16">
                <div className="aspect-video bg-slate-800 flex items-center justify-center border-b border-slate-800" data-id="element-17">
                  <Package className="w-16 h-16 text-slate-700" data-id="element-18" />
                </div>
                <div className="p-6" data-id="element-19">
                  <p className="text-slate-500 text-sm" data-id="element-20">
                    Direct-to-consumer ecommerce brand
                  </p>
                </div>
              </div>

              {/* Brand Placeholder 2 */}
              <div className="group border border-slate-800 rounded-xl overflow-hidden bg-slate-900/50" data-id="element-21">
                <div className="aspect-video bg-slate-800 flex items-center justify-center border-b border-slate-800" data-id="element-22">
                  <Package className="w-16 h-16 text-slate-700" data-id="element-23" />
                </div>
                <div className="p-6" data-id="element-24">
                  <p className="text-slate-500 text-sm" data-id="element-25">
                    Direct-to-consumer ecommerce brand
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 border-t border-slate-800/50" data-id="element-26">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-28">
              <div data-id="element-29">
                <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mb-4" data-id="element-30">
                  <Globe className="w-6 h-6 text-slate-400" data-id="element-31" />
                </div>
                <h3 className="text-lg font-semibold mb-2" data-id="element-32">
                  Direct-to-Consumer
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed" data-id="element-33">
                  Operating ecommerce brands with direct customer relationships
                  and digital-first distribution.
                </p>
              </div>

              <div data-id="element-34">
                <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mb-4" data-id="element-35">
                  <TrendingUp className="w-6 h-6 text-slate-400" data-id="element-36" />
                </div>
                <h3 className="text-lg font-semibold mb-2" data-id="element-37">
                  Performance Marketing
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed" data-id="element-38">
                  Data-driven acquisition and retention strategies across owned
                  brand portfolio.
                </p>
              </div>

              <div data-id="element-39">
                <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mb-4" data-id="element-40">
                  <Package className="w-6 h-6 text-slate-400" data-id="element-41" />
                </div>
                <h3 className="text-lg font-semibold mb-2" data-id="element-42">
                  Brand Development
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed" data-id="element-43">
                  Building and scaling consumer brands through creative and
                  operational excellence.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-slate-800 mt-20" data-id="element-44">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-46">
            <div className="flex items-center gap-2" data-id="element-47">
              <div className="w-8 h-8 bg-gradient-to-br from-slate-700 to-slate-800 rounded flex items-center justify-center font-bold text-sm tracking-tighter border border-slate-700" data-id="element-48">
                CS
              </div>
              <span className="font-semibold text-slate-300" data-id="element-49">
                Seiji Commerce Solutions
              </span>
            </div>
            <p className="text-slate-500 text-sm" data-id="element-50">
              © 2025 Seiji Commerce Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}